import * as React from 'react';

import type { NextPage } from 'next';

import { HomePage } from '@itp/talent/pages/homePage';

const Page: NextPage = () => {
  return (
    <>
      <HomePage />
    </>
  );
};

export default Page;
